import { useState, MouseEvent, FC } from 'react';

import { CirclePlus, Pencil, Trash2, ChevronDown } from 'lucide-react';
import { BaseMenu, BaseMenuItem } from 'wbs-components-lib';

import { Accordion, AccordionSummary, Tooltip, Typography, Box, AccordionDetails } from '@mui/material';

import { textStyles } from '@shared/styles';

import { VipLevelElementProps } from './types';
import { VipLevelRewards } from './VipLevelRewards';

import styles from './VipLevelElement.module.css';

const { defaultText } = textStyles;

const { vipLevelReward, actionsContainer } = styles;

export const VipLevelElement: FC<VipLevelElementProps> = ({
  vipLevel,
  handleVipLevelRewardsExpand,
  expandedVipLevelRewardsId,
  handleVipLevelEditModalOpen,
  handleVipLevelDeleteModalOpen,
  handleVipLevelRewardEditModalOpen,
  handleVipLevelRewardDeleteModalOpen,
  handleVipLevelRewardCreateModalOpen,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const { id: vipLevelId, title, level, levelPoints } = vipLevel;

  const menuItems: BaseMenuItem[] = [
    {
      icon: <Pencil />,
      text: 'Edit',
      onClick: () => handleVipLevelEditModalOpen(vipLevel),
    },
    {
      icon: <CirclePlus />,
      text: 'Create level reward',
      onClick: () => handleVipLevelRewardCreateModalOpen(vipLevel),
    },
    {
      icon: <Trash2 />,
      text: 'Delete',
      onClick: () => handleVipLevelDeleteModalOpen(vipLevel),
    },
  ];

  const handleItemsExpand = () => {
    const currentVipLevelRewardsIdExpanded = isItemsExpanded ? '' : vipLevelId;

    handleVipLevelRewardsExpand(currentVipLevelRewardsIdExpanded);
  };

  const isItemsExpanded = expandedVipLevelRewardsId === vipLevelId;
  const expandSlotsTitle = `${isItemsExpanded ? 'Collapse' : 'Expand'} level rewards`;

  return (
    <Accordion expanded={isItemsExpanded}>
      <AccordionSummary
        expandIcon={
          <Tooltip title={expandSlotsTitle}>
            <ChevronDown onClick={handleItemsExpand} />
          </Tooltip>
        }
        className={vipLevelReward}
      >
        <Tooltip title={title} placement="top-start">
          <Typography className={defaultText}>Name: {title}</Typography>
        </Tooltip>
        <Tooltip title={level} placement="top-start">
          <Typography className={defaultText}>Level: {level}</Typography>
        </Tooltip>
        <Tooltip title={levelPoints} placement="top-start">
          <Typography className={defaultText}>Level points: {levelPoints}</Typography>
        </Tooltip>
        <Box className={actionsContainer}>
          <Typography marginLeft="10px" className={defaultText}>
            Settings:
          </Typography>
          <BaseMenu
            menuItems={menuItems}
            menuAnchor={menuAnchor}
            isMenuOpened={isMenuOpened}
            handleOpenMenu={handleOpenMenu}
            handleCloseMenu={handleCloseMenu}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <VipLevelRewards
          vipLevel={vipLevel}
          isItemsExpanded={isItemsExpanded}
          handleVipLevelRewardEditModalOpen={handleVipLevelRewardEditModalOpen}
          handleVipLevelRewardDeleteModalOpen={handleVipLevelRewardDeleteModalOpen}
        />
      </AccordionDetails>
    </Accordion>
  );
};
